// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"142":"feather","997":"clipboard"}[chunkId] + "." + {"142":"1e46ed9741e9f02e96f4cf242b87","997":"9ecfb6b401b4ecd742b74cc33e28"}[chunkId] + ".js";
};